/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedCategory
 */
export interface PatchedCategory {
    /**
     * 
     * @type {number}
     * @memberof PatchedCategory
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedCategory
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCategory
     */
    description?: string;
}

export function PatchedCategoryFromJSON(json: any): PatchedCategory {
    return PatchedCategoryFromJSONTyped(json, false);
}

export function PatchedCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function PatchedCategoryToJSON(value?: PatchedCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

